/* eslint-disable @typescript-eslint/no-non-null-assertion */


export const msalConfig = { 

  auth: {
    authority: process.env.REACT_APP_MSAL_AUTHORITY!, // Or "https://login.microsoftonline.com/common" for multi-tenant
    clientId: process.env.REACT_APP_CLIENT_ID!, // Your Azure AD App client ID
    knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY!],
    redirectUri:  window.location.origin // The URL to redirect to after login
  },
  
  cache: {
    cacheLocation: "sessionStorage", // Cache location: "localStorage" or "sessionStorage"
    storeAuthStateInCookie: true, // Set to true if issues with cookies in certain browsers
  }
  
}

export const loginRequest = {
 scopes: [process.env.REACT_APP_SCOPE!] 
}

